// initial account creation steps
export const queryParamsVerifyAge = new URLSearchParams({
  'signup-step': 'verify_age',
});

export const queryParamsCreateProfile = new URLSearchParams({
  'signup-step': 'create_profile',
});

export const queryParamsUploadPhoto = new URLSearchParams({
  'signup-step': 'upload_photo',
});

export const queryParamsUploadVideo = new URLSearchParams({
  'signup-step': 'upload_video',
});

export const queryParamsUploadAudio = new URLSearchParams({
  'signup-step': 'upload_audio',
});

// Mobile registration steps

export const registrationStepIds = {
  verifyAge: 'verify-age',
  setupProfilePart1: 'setup-profile-part-1',
  setupProfilePart2: 'setup-profile-part-2',
  setupProfile: 'setup-profile',
};

export const queryParamsMobileVerifyAge = new URLSearchParams({
  step: registrationStepIds.verifyAge,
});

export const queryParamsMobileProfileSetupPartOne = new URLSearchParams({
  step: registrationStepIds.setupProfilePart1,
});

export const queryParamsMobileProfileSetupPartTwo = new URLSearchParams({
  step: registrationStepIds.setupProfilePart2,
});

// paywall steps for membership

export const queryParamsSelectMembership = new URLSearchParams({ 'signup-step': 'select_membership' });

export const queryParamsMembershipSummary = new URLSearchParams({
  'signup-step': 'membership_summary',
});

export const queryParamsMembershipSuccess = new URLSearchParams({ 'signup-step': 'membership_success' });
